export enum UserContactPointType {
	Email = 'EMAIL',
	InApp = 'IN_APP',
	Telegram = 'TELEGRAM',
}
